/*** IMPORTS FROM imports-loader ***/
import "core-js/modules/es.promise";
import "core-js/modules/es.array.iterator";

import { Swiper, Navigation, Pagination, Keyboard, Thumbs } from 'swiper';

Swiper.use([Navigation, Pagination, Keyboard, Thumbs]);

export default Swiper;